/**
 * User
 */
export const USER_INIT = 'USER_INIT'

/**
 * FeatureFlags actions
 */
export const FEATURE_FLAGS_RECEIVED = 'FEATURE_FLAGS_RECEIVED'

/**
 * Fetch Assets
 */
export const ASSET_SELECTED = 'ASSET_SELECTED'
export const MAP_ASSET_SELECTED = 'MAP_ASSET_SELECTED'
export const TRIGGERED_MOUSE_EVENT_FLAG = 'TRIGGERED_MOUSE_EVENT_FLAG'
export const ASSETS_FETCH_START = 'ASSETS_FETCH_START'
export const ASSETS_FETCH_SUCCESS = 'ASSETS_FETCH_SUCCESS'
export const ASSETS_FETCH_FAIL = 'ASSETS_FETCH_FAIL'
export const ASSETS_TRACK_LATEST_SEARCH = 'ASSETS_TRACK_LATEST_SEARCH'
export const ADGLARE_CONTENT_FETCHED = 'ADGLARE_CONTENT_FETCHED'

/**
 * Save Assets
 */
export const UPDATE_PROPERTY_SAVE_STATE = 'UPDATE_PROPERTY_SAVE_STATE'
export const UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER =
  'UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER'

/**
 * Marketing Tags
 */
export const MARKETING_TAGS_CONFIG_INIT = 'MARKETING_TAGS_CONFIG_INIT'

/**
 * Save Search
 */
export const SAVED_SEARCH_OPEN_MODAL = 'SAVED_SEARCH_OPEN_MODAL'
export const SAVED_SEARCH_CLOSE_MODAL = 'SAVED_SEARCH_CLOSE_MODAL'
export const SAVED_SEARCH_LOOKUP = 'SAVED_SEARCH_LOOKUP'
export const SAVED_SEARCH_ADDED = 'SAVED_SEARCH_ADDED'

/**
 * Notification
 */
export const NOTIFICATION_UPDATE = 'NOTIFICATION_UPDATE'
